import React, { Component } from "react";
import Select from "react-select";
import {
  formatoSeparadorMilesReturn,
  formatoSeparadorMilesValue,
} from "./utils/FormatoInput";

const tipoCuenta = {
  ahorro_vista: "AHORRO_VISTA",
  ahorro_programado: "AHORRO_PROGRAMADO",
  rueda_gigante: "RUEDA_GIGANTE",
};

export default class CuentaDeposito extends Component {
  constructor(props) {
    super(props);
     
  }

  componentDidMount() {}

  obtenerTitulo() {
    switch(this.props.operacion){
      case "CREDITO":
        return (
          <label className="input-label-bold">
            Seleccione la Cuenta Destino (a acreditar) *
          </label>
        );
      case "DEBITO":
        return (
          <label className="input-label-bold">
            Seleccione la Cuenta a (a debitar) *
          </label>
        );
      default:
        return (
          <label className="input-label-bold">
            Seleccione la Cuenta Origen (a debitar) *
          </label>
        );  
    }
    
  }

  handleChangeSelector = (selectedOption) => {
    var item = this.props.items;
    if (selectedOption === null) {
      this.props.selectorValue({}, []);
    } else {
      for (var i = 0; i < item.length; i++) {
        if (selectedOption.value === item[i].ahorro) {         
          this.props.selectorValue(item[i], selectedOption);
          break;
        }
      }
    }
  };

  handleChangeMonto = (evt) => {
    var _monto = formatoSeparadorMilesReturn(evt);
    if(_monto.length>1 && _monto.substr(0,1)==="0"){
      _monto = _monto.substr(1);
    }
    
    this.props.montoValue(_monto);
  };

  obtenerCuenta() {
    switch (this.props.tipoCuenta) {
      case tipoCuenta.ahorro_vista:
        var item = this.props.items;
        var options = [];
        if(item !== null){
          for (var i = 0; i < item.length; i++) {
            options.push({
              value: item[i].ahorro,
              label:
                item[i].ahorro +
                "-" +
                item[i].descripcion +
                " Saldo: " +
                formatoSeparadorMilesValue(item[i].saldoTotal) +
                " " +
                item[i].moneda +
                ".",
            });
          }
        }

        return (
          <div>
            <Select
              required="required"
              placeholder="-- Seleccione --"
              value={this.props.itemSelected}
              onChange={this.handleChangeSelector}
              options={options}
              isClearable
              noOptionsMessage={() => "SIN DATOS"}
            />
          </div>
        );

      case tipoCuenta.ahorro_programado:
        return <div className="form-group"></div>;
      case tipoCuenta.rueda_gigante:
        return <div className="form-group"></div>;
    }
  }

  render() {
   // const { selectedOption } = this.state;
    return (
      <div>
        <div className="form-group">
        <label className="input-label-bold">
            Seleccione la Cuenta Destino (a acreditar) *
          </label>
          {this.obtenerCuenta()}
        </div>
      
      </div>
    );
  }
}
